import React, {memo} from 'react';

import {getEmojiSheetCss} from '../../../../srcCommon/helpers/emoji/emojiHelpers';
import {EmojiInheritableProps} from '../../../services/emojis/emojiTypes';

/*
 * Component.
 */

// Always use the Emoji component if you want support for custom emojis
export const SheetEmoji = memo<EmojiInheritableProps>((props) => {
  const {emoji, skinTone} = props;
  const style = getEmojiSheetCss(emoji, skinTone);

  return (
    <div
      style={{
        ...style,
        height: props.size || '100%',
        width: props.size || '100%',
      }}
    />
  );
});
